import { Pipe, PipeTransform } from '@angular/core';

export type SortingPipeOrder = 'asc' | 'desc';

@Pipe({
	name: 'sortDate',
})
export class DateSortingPipe implements PipeTransform {
	transform<T>(array: T[], key: keyof T, order: SortingPipeOrder = 'asc'): T[] {
		if (!array) {
			return [];
		}

		const copyArray = [...array];
		return copyArray.sort((a, b) => {
			const dateA = new Date(a[key] as Date).getTime();
			const dateB = new Date(b[key] as Date).getTime();

			return order === 'desc' ? dateB - dateA : dateA - dateB;
		});
	}
}
